import Loadable from '../../components/loadable';

const VideoPlayer = Loadable({
  loader: () => import('../../components/video_player'),
  type: 'block',
});

angular.module('shared').value('VideoPlayer', VideoPlayer);
